var map = {
	"./FUMIN.png": "wqMN",
	"./HUARUN.png": "BQmd",
	"./PINGAN.png": "ekVP",
	"./SANXIANG.png": "dHvS",
	"./WHLH.png": "Db4K",
	"./WZ.png": "ceT7",
	"./YNHT.png": "qMwh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CJNS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bankInfoBg ^\.\/.*\.png$
// module id = CJNS
// module chunks = 17